import { IMarkdownProps } from './Markdown/Markdown.types'
import { IImageWidgetProps } from './ImageWidget/ImageWidget.types'
import { IVideoProps } from './Video/Video.types'
import { IEmbeddedCodeProps } from './EmbeddedCode/EmbeddedCode.types'

export const Widgets = {
  Markdown: 'markdown',
  Image: 'image',
  Video: 'video',
  EmbeddedCode: 'embeddedCode',
} as const

export interface IMarkdown {
  markdown?: IMarkdownProps
}

export interface IImageWidget {
  image?: IImageWidgetProps
}

export interface IVideo {
  video?: IVideoProps
}

export interface IEmbeddedCode {
  embeddedCode?: IEmbeddedCodeProps
}

export interface IWidget extends IMarkdown, IImageWidget, IVideo, IEmbeddedCode {
  type: typeof Widgets[keyof typeof Widgets]
}

export interface IWidgetProps {
  component: IWidget
  customStyles?: boolean
}
